import { Select, Spin } from 'antd';
import { debounce, get } from 'lodash';
import React, { useMemo, useState } from 'react';
import { useLazyQuery } from 'react-apollo';
import { INVESTORS } from '../../pages/apollo_queries';
import { personName } from './shared';

export const investorLabel = (user) => {
  const name = personName(user);
  return user.email && name !== user.email ? `${name} · ${user.email}` : name;
};

// Picks ONE user through `adminUsers(q)` (name, email or id) and hands back their `id` — the PERSON's
// id, which is what the exception ops take (never an account id). Works as a Form.Item child (`id`,
// `value`, `onChange` come from it).
export function InvestorSelect({ id, value, onChange, placeholder, style, disabled, autoFocus }) {
  const [search, { data, loading }] = useLazyQuery(INVESTORS, { fetchPolicy: 'network-only' });
  // The picked user stays in the options so the label survives a new search.
  const [picked, setPicked] = useState(null);
  const onSearch = useMemo(
    () =>
      debounce((typed) => {
        const q = typed.trim();
        if (q) search({ variables: { q, count: 10, page: 1 } });
      }, 300),
    [search]
  );

  const results = get(data, 'adminUsers.items', []);
  const users = picked && !results.some((u) => u.id === picked.id) ? [picked, ...results] : results;

  return (
    <Select
      id={id}
      showSearch
      allowClear
      value={value}
      disabled={disabled}
      autoFocus={autoFocus}
      placeholder={placeholder || 'Search by name, email or id'}
      style={style || { width: '100%' }}
      filterOption={false}
      onSearch={onSearch}
      notFoundContent={loading ? <Spin size="small" /> : null}
      options={users.map((user) => ({ value: user.id, label: investorLabel(user), user }))}
      onChange={(id, option) => {
        const user = option ? option.user : null;
        setPicked(user);
        if (onChange) onChange(id, user);
      }}
    />
  );
}
